module.exports = __webpack_public_path__ + "toGroom-we-p-n.254619eb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/toGroom-we-p-n.jpg
// module id = 12hp
// module chunks = 0